import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
    transitionProperty: "transform, height",
    transitionDuration: "300ms",
    transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
}));

export const Content = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: theme.gridTemplateColumns[1],
    transitionProperty: "transform, height",
    transitionDuration: "300ms",
    transitionTimingFunction: theme.transitionTimingFunction["out-cubic"],
}));
